import { render, staticRenderFns } from "./panziStarterPage.vue?vue&type=template&id=40c0f2f4&scoped=true&"
import script from "./panziStarterPage.vue?vue&type=script&lang=js&"
export * from "./panziStarterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c0f2f4",
  null
  
)

export default component.exports